// extracted by mini-css-extract-plugin
export var blurred = "pYov6";
export var darkGradient = "z5SNc";
export var gradient = "HsBja";
export var lightGradient = "u7n30";
export var neutralBackground = "vZhVA";